import React from "react";
import TariffsList from "../../components/tariffs/TariffsList";
import { fetchPage } from "./tariffsSlice";
import { useSelector } from "react-redux";
import {
  loadRecord,
  reset,
  deleteRecord,
  createRecord,
  updateRecord,
  updateRecordVersion,
  deleteRecordVersion,
  createRecordVersion,
} from "../tariff/tariffSlice";

const Tariffs = () => {
  const items = useSelector((state) => state.tariffs.items);
  const total = useSelector((state) => state.tariffs.total);
  const loading = useSelector(
    (state) => state.pendingActions["tariffs/loadPage"]
  );
  const createLoading = useSelector(
    (state) => state.pendingActions["tariffDetails/create"]
  );
  const deleteLoading = useSelector(
    (state) => state.pendingActions["tariffDetails/delete"]
  );
  const updateLoading = useSelector(
    (state) => state.pendingActions["tariffDetails/update"]
  );
  const versionCreateLoading = useSelector(
    (state) => state.pendingActions["tariffVersion/create"]
  );
  const versionUpdateLoading = useSelector(
    (state) => state.pendingActions["tariffVersion/update"]
  );
  const versionDeleteLoading = useSelector(
    (state) => state.pendingActions["tariffVersion/delete"]
  );
  const activeTariff = useSelector((state) => state.tariff.activeTariff);

  return (
    <TariffsList
      items={items}
      loading={loading}
      changeLoading={
        createLoading ||
        updateLoading ||
        versionCreateLoading ||
        versionUpdateLoading ||
        versionDeleteLoading
      }
      deleteLoading={deleteLoading}
      activeTariff={activeTariff}
      fetchPage={fetchPage}
      loadRecord={loadRecord}
      reset={reset}
      deleteRecord={deleteRecord}
      createRecord={createRecord}
      updateRecord={updateRecord}
      updateRecordVersion={updateRecordVersion}
      deleteRecordVersion={deleteRecordVersion}
      createRecordVersion={createRecordVersion}
      type="wage"
      total={total}
    />
  );
};
export default Tariffs;
